<template>
    <div v-show="can.create.room">
        <button-primary @click="showModal = true">
            <template slot="icon"><i class="fa fa-plus"></i></template> Raum hinzufügen
        </button-primary>

        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">

                <template v-slot:header>Raum hinzufügen</template>

                <input-text class="mb-4" v-model="name">
                    Raumname
                </input-text>

                <input-text class="mb-4" v-model="limit_persons">
                    Maximale Anzahl an Personen (Corona)
                    <template v-slot:helper>Leeres Feld: jeder Schreibtisch kann genutzt werden.</template>
                </input-text>

                <div v-if="floor" class="mb-4">
                    <label class="block text-sm font-medium leading-5 text-gray-700">Etage</label>
                    <div class="mt-1 relative rounded-md shadow-sm">
                        <input disabled :value="floor.name"
                               class="bg-gray-200 form-input block w-full sm:text-sm sm:leading-5" placeholder=""/>
                    </div>
                </div>

                <div class="flex justify-end">
                    <button-primary @click="create"><template slot="icon"><i class="fa fa-plus"></i></template> Raum hinzufügen</button-primary>
                </div>

            </modal>
        </portal>
    </div>
</template>

<script>
import ButtonPrimary from "./UI/ButtonPrimary";
import InputText from "./UI/InputText";
import Modal from "./Modal";

export default {
    name: "RoomCreate",

    components: {Modal, InputText, ButtonPrimary},

    props: {
        floor: {
            default: null,
        }
    },

    data: () => ({
        showModal: false,
        loading: false,
        limit_persons: null,
        name: '',
        saved: false,
    }),

    inject: ['can'],

    methods: {
        create() {
            this.loading = true;
            window.axios.post('/admin/rooms', {
                name: this.name,
                limit_persons: this.limit_persons,
                floor_id: this.floor ? this.floor.id : null,
            }).then(() => {
                this.loading = false;
                this.$emit('reload');
                this.showModal = false;
                this.saved = true;
            }).catch(error => {
                this.$root.$emit('error', error);
            })
        }
    }
}
</script>

<style scoped>

</style>
